import { useEffect } from "react";

const NON_TEXT_INPUT_TYPES = new Set([
  "button",
  "checkbox",
  "color",
  "file",
  "hidden",
  "image",
  "radio",
  "range",
  "reset",
  "submit",
]);

const isTextEditingElement = (element) => {
  if (!(element instanceof HTMLElement)) return false;
  if (element.isContentEditable) return true;
  if (element instanceof HTMLTextAreaElement) return true;
  if (element instanceof HTMLInputElement) {
    return !NON_TEXT_INPUT_TYPES.has(String(element.type || "").toLowerCase());
  }
  return false;
};

const blurActiveTextField = () => {
  if (typeof document === "undefined") return;
  const activeElement = document.activeElement;
  if (isTextEditingElement(activeElement)) {
    activeElement.blur();
  }
};

const useDisableMobileTextAutofocus = (open) => {
  useEffect(() => {
    if (!open || typeof window === "undefined") return undefined;
    if (!window.matchMedia("(max-width: 600px)").matches) return undefined;

    const frameId = window.requestAnimationFrame(blurActiveTextField);
    const timeoutId = window.setTimeout(blurActiveTextField, 180);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearTimeout(timeoutId);
    };
  }, [open]);
};

export default useDisableMobileTextAutofocus;
